import type { FaireProductEntity } from "../../entity_types/product";

export const p_778bqczu6u: FaireProductEntity = {
  token: "p_778bqczu6u",
  type: "product",
  name: "Boho-Chic Hand-Block Printed Cotton Midi Dress -(Bethany)",
  brandToken: "b_3dexc9gstg",
  brandName: "Thuli",
  imageUrl:
    "https://cdn.faire.com/fastly/4df2faa8e4649cb908d86817ebcbac0d7411d13abb9b31dbc25862a3ab5d7f16.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0a3c6c85e2ebdec430b1c9c6809407702d2467bb31e8858517461f1d69c3972a.jpeg",
    "https://cdn.faire.com/fastly/fb272c1b6606e1ab17912103060839774a0d3777f8b475e403ea69ccd16ebaee.jpeg",
    "https://cdn.faire.com/fastly/201496600a996da56758b27faf090670464d70366582516e196db0608a0318aa.jpeg",
    "https://cdn.faire.com/fastly/d0ac3043bfe984d8d751f03e473476c9f3c22d4002fe668bca8074e5f651fc9a.jpeg",
  ],
  priceDollars: 118,
  description:
    "This is a go to piece if you wanna just throw on one piece and look effortless yet classy. An easy laid back dress in artisanal hand-block printed fabric. Ethically hand-crafted by our artisans in Kutch.\n\n• Green/Black\n• Hand-woven cotton\n• Khadi cotton\n• Half sleeves\n• Hand-block printed\n• Side pockets\n• Midi dress\n• Easy relaxed fit\n\nThis product has passed through a few beautiful hands to get to you!",
  tags: [],
  msrpDollars: 295,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:20:01.457Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
